const FromArr = [
  {
    modelvalue: "",
    title: "经销商名称：",
    inputtype: "input",
    inputflag: true,
    fontSize: 14,
    color: "#333333",
    lableheight: 20,
    X: false,
    types: "text",
    placeholder: "请输入",
    width: 180,
    height: 32,
    disabled: false,
    marginLeft: 15,
    marginTop: 5,
    displayVal: "inline-block",
    fontWeightVal: 500
  },
  {
    modelvalue: "",
    title: "申请单号：",
    inputtype: "input",
    inputflag: true,
    fontSize: 14,
    color: "#333333",
    lableheight: 20,
    X: false,
    types: "text",
    placeholder: "请输入",
    width: 180,
    height: 32,
    disabled: false,
    marginLeft: 65,
    marginTop: 5,
    displayVal: "inline-block",
    fontWeightVal: 500
  },
  {
    modelvalue: "",
    title: "年份：",
    inputtype: "select",
    inputflag: true,
    fontSize: 14,
    color: "#333333",
    lableheight: 20,
    X: false,
    types: "",
    placeholder: "请选择",
    width: 192,
    height: 32,
    disabled: false,
    marginLeft: 42,
    marginTop: 15,
    displayVal: "inline-block",
    fontWeightVal: 500,
    options: []
  },
  {
    modelvalue: "",
    title: "产品线：",
    inputtype: "selectMultiple",
    inputflag: true,
    fontSize: 14,
    color: "#333333",
    lableheight: 20,
    X: false,
    types: "",
    placeholder: "请选择",
    width: 192,
    height: 32,
    disabled: false,
    marginLeft: 42,
    marginTop: 15,
    displayVal: "inline-block",
    fontWeightVal: 500,
    options: []
  },
  {
    modelvalue: "",
    title: "状态：",
    inputtype: "select",
    inputflag: true,
    fontSize: 14,
    color: "#333333",
    lableheight: 20,
    X: false,
    types: "",
    placeholder: "请选择",
    width: 470,
    height: 32,
    disabled: false,
    marginLeft: 95,
    marginTop: 15,
    displayVal: "inline-block",
    fontWeightVal: 500,
    options: []
  },
  {
    title: "创建时间：",
    StartTime: '',
    EndTime: '',
    inputtype: "dateSection",
    inputflag: true,
    fontSize: 14,
    color: "#333333",
    lableheight: 20,
    X: false,
    types: "date",
    placeholder: "发布时间",
    widthLeft: 190,
    widthRight: 580,
    heightLeft: 32,
    heightRight: 32,
    disabled: false,
    marginLeft: 30,
    marginTop: 15,
    displayVal: "inline-block",
    fontWeightVal: 500
  },
];
export default FromArr;
